module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av572-18ad2705711040c4fd28816c697dd4de.jpg";